import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAPI } from '../hooks/useAPI';
import { contentAPI } from '../services/api';

const About = () => {
  const { data: content, loading, error } = useAPI(contentAPI.getAboutContent, []);

  if (loading) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-900 mx-auto mb-4"></div>
            <p className="text-xl text-gray-900 font-medium">Loading content...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Content</h2>
            <p className="text-gray-900 font-medium">{error}</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div>
        <section className="overflow-hidden">
          <Header variant="light" />
        </section>
      </div>

      {/* Hero Section */}
      <section className="relative py-12 lg:py-24 overflow-hidden">
        <img className="absolute bottom-0 left-0" src="/fauna-assets/about/lines.svg" alt="" />
        <div className="container mx-auto px-4 relative">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-heading text-5xl sm:text-6xl mb-8 text-gray-900 font-bold">{content?.hero?.title || 'About us'}</h1>
            <p className="text-2xl text-black font-medium">
              {content?.hero?.subtitle || ''}
            </p>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-12 lg:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-4xl sm:text-5xl mb-8 text-gray-900 font-bold">{content?.about?.title || 'Our Story'}</h2>
            <p className="text-base md:text-lg leading-relaxed text-gray-900 font-medium mb-8">
              {content?.about?.description || ''}
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-12 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-4xl sm:text-5xl mb-8 text-gray-900 font-bold">{content?.mission?.title || 'Our Mission'}</h2>
            <p className="text-lg leading-relaxed text-gray-900 font-medium">
              {content?.mission?.description || ''}
            </p>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-12 lg:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-4xl sm:text-5xl mb-8 text-gray-900 font-bold">{content?.vision?.title || 'Our Vision'}</h2>
            <p className="text-lg leading-relaxed text-gray-900 font-medium">
              {content?.vision?.description || ''}
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-12 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="font-heading text-4xl sm:text-5xl mb-16 text-center text-gray-900 font-bold">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            {content?.values && content.values.map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition duration-300">
                <h3 className="font-heading text-2xl mb-4 text-gray-900 font-bold">{value.title}</h3>
                <p className="text-gray-900 font-medium leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;
